export default __webpack_public_path__ + "static/media/Group 25.91a87a00.svg";